// Who is signed in, as far as the SPA knows. Replaces supabase.auth.onAuthStateChange: the API sets an HttpOnly
// cookie the SPA cannot read, so the state is learned from login, logout, /auth/me and 401 responses.
// Listeners only fire when the user actually changes, so a 401 on an anonymous page cannot start a refetch loop.

type AuthListener = (userId: string | null, previousUserId: string | null | undefined) => void

let currentUserId: string | null | undefined
const listeners = new Set<AuthListener>()

export const authEvents = {
  /** undefined until the first /auth/me answer or login. */
  get userId(): string | null | undefined {
    return currentUserId
  },

  setUser(userId: string | null) {
    if (userId === currentUserId) {
      return
    }

    const previous = currentUserId
    currentUserId = userId
    for (const listener of listeners) {
      listener(userId, previous)
    }
  },

  subscribe(listener: AuthListener): () => void {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
}
